import type { ITranslateServerMessageProps } from "./translate-server-message.types";

// NOTE: Matches a bare i18n key like "customIntegration.error.name_already_exists"
// (dotted, no whitespace) so we don't run real prose through the translator.
const KEY_LIKE_MESSAGE_REGEX = /^[a-zA-Z][\w-]*(?:\.[\w-]+)+$/;

// NOTE: Some domain errors are surfaced by the backend as stable i18n keys
// rather than prose (e.g. `user_memory.blocked_content`) — the server's
// AllExceptionsFilter only translates DTO validation arrays, so plain
// HttpException messages arrive as the raw key. The backend joins the namespace
// with ".", while i18next expects ":", so swap the first separator and only
// translate when the key actually exists — otherwise the message is genuine
// prose and is returned untouched. NSAI-6252 lifted this out of the web app so
// mobile resolves the same keys instead of toasting them raw.
export const translateServerMessage = ({
  message,
  translator,
}: ITranslateServerMessageProps): string => {
  if (!KEY_LIKE_MESSAGE_REGEX.test(message)) return message;
  const separatorIndex = message.indexOf(".");
  const namespacedKey = `${message.slice(0, separatorIndex)}:${message.slice(
    separatorIndex + 1,
  )}`;
  return translator.exists(namespacedKey)
    ? translator.t(namespacedKey)
    : message;
};
